/* tslint:disable */
/* eslint-disable */
/**
 * Swipe4Work Employer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { LocationDtoFromJSON, LocationDtoToJSON, } from './LocationDto.js';
/**
 * Check if a given object implements the GetLocationDetailsResult interface.
 */
export function instanceOfGetLocationDetailsResult(value) {
    if (!('location' in value) || value['location'] === undefined)
        return false;
    return true;
}
export function GetLocationDetailsResultFromJSON(json) {
    return GetLocationDetailsResultFromJSONTyped(json, false);
}
export function GetLocationDetailsResultFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'location': LocationDtoFromJSON(json['location']),
    };
}
export function GetLocationDetailsResultToJSON(json) {
    return GetLocationDetailsResultToJSONTyped(json, false);
}
export function GetLocationDetailsResultToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'location': LocationDtoToJSON(value['location']),
    };
}
